<div class="form-group row" *ngIf="this.loadingInProgress">
  <div class="col-md-12">
    Retrieving product data...<i class="fa fa-spinner fa-spin fa-lg fa-fw"></i>
  </div>
</div>
<div class="form-group row" *ngIf="!this.loadingInProgress">
  <div class="col-md-12">
    <table class="table table-striped table-responsive">
      <thead *ngIf="productApiGrid !== null && productApiGrid.columns !== null">
        <tr>
          <th>&nbsp;</th>
          <ng-container *ngFor="let item of productApiGrid.columns">
            <th>{{item.columnName}}</th>
          </ng-container>
        </tr>
      </thead>
      <thead *ngIf="this.productApiGrid !== null && this.productApiGrid.columns !== null">
        <tr>
          <th>&nbsp;</th>
          <ng-container *ngFor="let item of productApiGrid.columns">
            <th>
              <input style="min-width: 150px;" type="text" class="form-control" [value]="this.getColumnFilterValue(item)" placeholder="Filter By {{item.columnName}}..."
            (keyup)='onColumnFilter($event,item)' [readOnly]="filteringInProgress" />
            <div *ngIf="this.filteringInProgress && this.activeColumn.columnName === item.columnName"><i class="fa fa-spinner fa-spin fa-lg fa-fw"></i></div>
            <div *ngIf="this.filteringInProgress && this.activeColumn.columnName !== item.columnName">&nbsp;</div>
            </th>
          </ng-container>
        </tr>
      </thead>
      <tbody *ngIf="productApiGrid !== null && productApiGrid.rows !== null">
        <tr *ngFor="let product of productApiGrid.rows; let i = index">
          <td>
            <div class="c-radio">
              <label>
                <input (change)="onRadioAssignProduct(product)" type="radio"
                  name="products" value="1" /><span class="fa fa-circle"></span>
              </label>
            </div>
          </td>
          <ng-container *ngFor="let column of productApiGrid.columns">
            <td *ngIf="selectColumnToDisplay(product.cells, column.columnName); let cell">
              <span *ngIf="cell.overrideDisplayValue === null">{{cell.defaultDisplayValue}}</span>
              <span *ngIf="cell.overrideDisplayValue !== undefined">{{cell.overrideDisplayValue}}</span>
            </td>
          </ng-container>
        </tr>
        <tr *ngIf="productApiGrid.rows !== undefined && productApiGrid.rows.length === 0">
          <td [colSpan]="this.productApiGrid.columns !== undefined ? this.productApiGrid.columns.length + 1: 0">No
            data found</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="form-group row" *ngIf="productApiGrid !== undefined && this.productApiGridFilter !== undefined && this.productApiGridFilter !== null && !this.filteringInProgress && !this.loadingInProgress">
  <pagination style="margin-left:20px" class="pagination-sm"
    [(ngModel)]="this.productApiGridFilter.page"
    [totalItems]="this.productApiGridFilter.totalItems"
    [itemsPerPage]="this.productApiGridFilter.pageSize"
    [maxSize]="this.maxSize"
    (numPages)="this.numPages = $event"
    [maxSize]="maxSize"
    [boundaryLinks]="true"
    (pageChanged)="onAssignProductPageChanged($event)">
  </pagination>
</div>
